import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import axiosInstance from "../config";
import ResultsLeagueFilter from "./ResultsLeagueFilter";
import {logout} from './Utils';
import "../styles/Results.css";
const useStyles = makeStyles((theme) => ({
  ml5: {
    marginLeft: "5px",
  },
  compName: {
    lineHeight: "16px",
    fontWeight: "normal",
    fontSize: "14px",
    color: "#323030",
    backgroundColor: "#DEDEDE",
    borderBottom: "1px solid #86898C",
    borderTop: "1px solid #86898C",
  },
  date: {
    color: "#18334C",
  },
  fh: {
    textAlign: "center",
    color: "#18334C",
  },
  ft: {
    textAlign: "center",
    color: "#18334C",
  },
  more: {
    textAlign: "center",
    color: "#18334C",
  },
  btnWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  form: {
    marginBottom: "1rem",
  },
  header: {
    color: "#18334C",
    fontSize: "14px",
    marginRight: "1rem",
  },
  flex: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "10px",
    maxHeight: "18px",
  },
  flex2: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  img: {
    height: "18px",
    width: "18px",
  },
  mr5: {
    marginRight: "0.5rem",
  },
  btn: {
    background: "#fff",
    color: "#323030",
    border: "1px solid #18334C",
    fontSize: "14px",
    boxSizing: "border-box",
    textAlign: "center",
    fontWeight: "bold",
    borderRadius: "4px",
    marginRight: "4px",
    padding: "0.25rem 0.75rem",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  dd: {
    border: "1px solid #18334C",
    boxSizing: "border-box",
    borderRadius: "4px",
    fontSize: "14px",
    fontWeight: "bold",
    background: "#fff",
    color: "#323030",
    padding: "0.25rem 0.75rem",
    textAlign: "left",
    textAlignLast: "left",
    cursor: "pointer",
    height: "1.6rem",
  },
  selectleague: {
    background: "#fff",
    color: "#323030",
    border: "1px solid #18334C",
    fontSize: "14px",
    boxSizing: "border-box",
    textAlign: "center",
    fontWeight: "bold",
    borderRadius: "4px",
    marginLeft: "1rem",
    padding: "0.25rem 0.75rem",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  pl5: {
    paddingLeft: "0.5rem",
  },
  datePicker: {
    maxWidth: "100px",
    cursor: "pointer",
    textAlign: "center",
    fontWeight: "bold",
  },
  submit: {
    marginLeft: "1rem",
    cursor: "pointer",
  },
}));

const ResultsRightSide = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  // result table data
  const [result, setResult] = useState(null);
  // waiting for results to load up
  const [isResult, setIsResult] = useState(false);
  // date picker
  const [startDate, setStartDate] = useState();
  const [game, setGame] = useState();
  const [gameList, setGameList] = useState([]);
  const [openLeagueFilter, setOpenLeagueFilter] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [hiddenCompetitions, setHiddenCompetitions] = useState([]);
  const [competitionNames, setCompetitionNames] = useState([]);
  const [dateChanged, setDateChanged] = useState(0);
  const startDateRef = useRef(startDate);
  const history = useHistory();

  useEffect(() => {
    startDateRef.current = startDate;
  }, [startDate]);

  const handleGameChange = (event) => {
    //console.log(event.target.value);
    setGame(event.target.value);
  };

  const minusMonth = (d, month) => {
    d.setMonth(d.getMonth() - month);
    return d;
  };

  useEffect(() => {
    axiosInstance
      .get("public/selectSport")
      .then((res) => {
        if (res.data && res.data.length > 0) {
          setGameList(res.data);
          setGame(res.data[0].key);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.data.status === 401) {
          logout(history);
        }
      });
  }, [history]);

  //handle more
  const handleMore = (e, index) => {
    let i = 0;
    while (i < 999) {
      const more = document.getElementById(index+'_'+i);
      if (more){
        more.classList.toggle("none");
        more.classList.toggle("show");
      }
      else {
        i = 999;
      }
      i++;
    }
  };
  // handle date
  const handleDate = (e, date) => {
    const parsed = moment(date);
    if (parsed.isValid()) {
      setStartDate(parsed.toDate());
      setDateChanged((d) => d + 1);
    }
    e.preventDefault();
  };

  useEffect(() => {
    if (openLeagueFilter) {
      window.scrollTo(0, 0);
    }
  }, [openLeagueFilter]);

  useEffect(() => {
    if (game) {
      console.info('refreshKey', refreshKey);
      console.info('game', game);
      console.info('dateChanged', dateChanged);
      var params = {
        searchSport: game,
      };

      const currentDate = startDateRef.current;
      if (currentDate) {
        params.reportDate = moment(currentDate).format("D-M-YYYY");
      }

      axiosInstance
        .get("public/results", {
          params: params,
        })
        .then((res) => {
          setResult(res.data);
          setIsResult(true);
          setHiddenCompetitions([]);
          const uniqueComps = [...new Set(
            (res.data.results || [])
              .filter((r) => r.competitionName)
              .map((r) => r.competitionName)
          )];
          setCompetitionNames(uniqueComps);
          if (!currentDate) {
            const parsed = moment(res.data.today);
            if (parsed.isValid()) {
              setStartDate(parsed.toDate());
            }
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.data.status === 401) {
            logout(history);
          }
        });
    }
  }, [history, game, dateChanged, refreshKey]);
  return (
    <>
      <div className="Results">
        {isResult !== null ? (
          <>
            {/* table for result */}
            {result !== null ? (
              <>
                <form action="" onSubmit={handleDate} id="form">
                  <div className={classes.flex}>
                    <div className={classes.flex2}>
                      {/* form  */}

                      <img
                        src={require("../img/Icons/chart-21.svg")}
                        alt=""
                        className={`${classes.img} ${classes.mr5}`}
                      />
                      <p className={classes.header}>
                        <span className={`lang-${localStorage.getItem('language')}`}>{t("Results")}</span>
                      </p>
                      <button
                        value={moment(result.today).format("D-M-YYYY")}
                        onClick={(e) => {
                          handleDate(e, result.today);
                        }}
                        className={classes.btn}
                      >
                        <span className={`lang-${localStorage.getItem('language')} lang-${localStorage.getItem('language')}-fs-12`}>{t("Today")}</span>
                      </button>
                      <button
                        value={moment(result.yesterday).format("D-M-YYYY")}
                        onClick={(e) => {
                          handleDate(e, result.yesterday);
                        }}
                        className={classes.btn}
                      >
                        <span className={`lang-${localStorage.getItem('language')} lang-${localStorage.getItem('language')}-fs-12`}>{t("Yesterday")}</span>
                      </button>
                      <select
                        value={game}
                        onChange={handleGameChange}
                        className={`${classes.dd} lang-${localStorage.getItem('language')} lang-${localStorage.getItem('language')}-fs-12`}
                      >
                        <optgroup className={`${classes.ml5} lang-${localStorage.getItem('language')} lang-${localStorage.getItem('language')}-fs-12`}>
                        {gameList.map((g, index) => (
                          <React.Fragment key={index}>
                            <option value={g.key}>{t(g.val)}</option>
                          </React.Fragment>
                        ))}
                        </optgroup>
                      </select>
                      <button
                        type="button"
                        onClick={() => setOpenLeagueFilter(true)}
                        className={classes.selectleague}
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 10 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10 1.25001C9.845 2.96042 8.83 4.62125 7.13625 5.1825C7.26 4.9525 7.38458 4.70542 7.50375 4.43959C8.71833 3.80584 9.18583 2.66875 9.36375 1.835H8.24375C8.26833 1.6475 8.28667 1.45084 8.30167 1.24959H10V1.25001ZM0 1.25001C0.155 2.96042 1.17 4.62125 2.86375 5.1825C2.74 4.9525 2.61542 4.70542 2.49625 4.43959C1.28167 3.80584 0.814167 2.66875 0.63625 1.835H1.75625C1.73208 1.64792 1.71375 1.45084 1.69875 1.25001H0ZM7.05042 1.25001C6.89708 3.1275 6.23667 4.2625 5.64542 5.27875C5.405 5.6925 5.17208 6.0925 5.0025 6.50792C4.8325 6.09209 4.59875 5.69167 4.3575 5.2775C3.765 4.26209 3.10292 3.12709 2.94958 1.25001H7.05042ZM7.91667 0.416672H2.08333C2.08333 4.50126 4.21042 5.85542 4.41833 7.5H5.58708C5.79417 5.85542 7.91667 4.50126 7.91667 0.416672ZM5.59917 7.91667H4.405C4.32083 8.41125 4.1425 9.00792 3.33375 9.00792V9.58334H6.66708V9.00792C5.83417 9.00792 5.67917 8.41125 5.59917 7.91667ZM4.08083 2.72L4.68917 2.63584L4.95708 2.08334L5.225 2.63584L5.83333 2.72L5.39042 3.14542L5.49875 3.75L4.95708 3.46042L4.41542 3.75L4.52375 3.14542L4.08083 2.72Z"
                            fill="#323030"
                          />
                        </svg>
                        <span
                          className={`${classes.pl5} lang-${localStorage.getItem(
                            'language'
                          )} lang-${localStorage.getItem('language')}-fs-12`}
                        >
                          {t('Select League')}
                        </span>
                      </button>
                    </div>
                    <div className={`${classes.flex2} float-right`}>
                      <DatePicker
                        placeholderText="Select date"
                        className={classes.datePicker}
                        closeOnScroll={false}
                        selected={startDate}
                        onChange={(date) => {
                          setStartDate(date);
                          setDateChanged((d) => d + 1);
                        }}
                        dateFormat="d MMM yyyy"
                        maxDate={new Date()}
                        minDate={minusMonth(new Date(), 1)}
                      />
                    </div>
                  </div>
                </form>
                <table>
                  <thead>
                    <tr>
                      <th style={{ borderRadius: "4px 0 0 0" }}>
                      <span className={`lang-${localStorage.getItem('language')}`}>{t("Date & Time")}</span>
                      </th>
                      <th><span className={`lang-${localStorage.getItem('language')}`}>{t("Event")}</span></th>
                      <th><span className={`lang-${localStorage.getItem('language')}`}>{t("First Half Score")}</span></th>
                      <th><span className={`lang-${localStorage.getItem('language')}`}>{t("Full Time Score")}</span></th>
                      <th style={{ borderRadius: "0 4px  0 0" }}>
                      <span className={`lang-${localStorage.getItem('language')}`}>{t("More")}</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      let currentCompetition = null;
                      return result.results.map((info, index) => {
                        if (info.competitionName !== undefined) {
                          currentCompetition = info.competitionName;
                        }
                        if (
                          currentCompetition &&
                          hiddenCompetitions.includes(currentCompetition)
                        ) {
                          return null;
                        }
                        return (
                          <React.Fragment key={index}>
                            {info.competitionName !== undefined ? (
                              <tr>
                                <td colSpan="5" className={classes.compName}>
                                  {info.competitionName}
                                </td>
                              </tr>
                            ) : null}
                            <tr>
                              <td className={classes.date}>
                                <p>
                                  {moment(info.matchTime).format("D MMM h:mm a")}
                                </p>
                              </td>
                              <td>
                                <p>
                                  {info.homeName} vs {info.awayName}
                                </p>
                              </td>
                              {info.ft && info.fh !== undefined ? (
                                <>
                                  <td className={classes.fh}>
                                    <p>
                                      {info.fh.length === 2 ? (
                                        <span>
                                          {info.fh[0]}:{info.fh[1]}
                                        </span>
                                      ) : (
                                        <span>{info.fh[0]}</span>
                                      )}
                                    </p>
                                  </td>
                                  <td className={classes.ft}>
                                    <p>
                                      {info.ft !== undefined &&
                                      info.ft.length === 2 ? (
                                        <span>
                                          {info.ft[0]}:{info.ft[1]}
                                        </span>
                                      ) : info.ft !== undefined ? (
                                        <span>{info.ft[0]}</span>
                                      ) : null}
                                    </p>
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td className={classes.fh}>-:-</td>
                                  <td className={classes.ft}>-:-</td>
                                </>
                              )}

                              <td className={classes.more}>
                                {info.more !== undefined ? (
                                  <button
                                    onClick={(e) => {
                                      handleMore(e, index);
                                    }}
                                  >
                                    +
                                  </button>
                                ) : null}
                              </td>
                            </tr>

                            {info.more !== undefined ? (
                              <>
                                {info.more.map((more, i) => (
                                  <tr key={i} id={index+'_'+i} className="none">
                                    <td />
                                    <td>{more.hdpType === 'CORNER' ? 'Total Corners' : more.hdpType === 'YELLOWCARD' ? 'Total Bookings' : more.hdpType === 'YELLOWCARDS' ? 'Yellow Cards' : more.hdpType}</td>
                                    {more.ft && more.fh !== undefined ? (
                                      <>
                                        <td className={classes.fh}>
                                          <p>
                                            {more.fh.length === 2 ? (
                                              <span>
                                                {more.fh[0]}:{more.fh[1]}
                                              </span>
                                            ) : (
                                              <span>{more.fh[0]}</span>
                                            )}
                                          </p>
                                        </td>
                                        <td className={classes.ft}>
                                          <p>
                                            {more.ft !== undefined &&
                                            more.ft.length === 2 ? (
                                              <span>
                                                {more.ft[0]}:{more.ft[1]}
                                              </span>
                                            ) : more.ft !== undefined ? (
                                              <span>{more.ft[0]}</span>
                                            ) : null}
                                          </p>
                                        </td>
                                      </>
                                    ) : (
                                      <>
                                        <td className={classes.fh}>-:-</td>
                                        <td className={classes.ft}>-:-</td>
                                      </>
                                    )}
                                    <td />
                                  </tr>
                                ))}
                              </>
                            ) : null}
                          </React.Fragment>
                        );
                      });
                    })()}
                  </tbody>
                </table>
                <ResultsLeagueFilter
                  openLeagueFilter={openLeagueFilter}
                  setOpenLeagueFilter={setOpenLeagueFilter}
                  competitionNames={competitionNames}
                  onFilterChange={setHiddenCompetitions}
                  hiddenCompetitions={hiddenCompetitions}
                />
              </>
            ) : null}
          </>
        ) : null}
      </div>
    </>
  );
};

export default ResultsRightSide;
